import React from 'react';
import ChatRenderer from './ChatRenderer'
import styles from './SmartTextArea.module.scss';

export default function SmartTextArea({chatRaw}) {
  return (
    <div className={styles.smarttextarea}
      id="arnoldText"
      tabIndex={0}
      role="textbox"
      aria-multiline="true"
      onMouseDown={e => {
       e.currentTarget.focus();
      }}
      aria-readonly={true}
    >
      <ChatRenderer chat={chatRaw.toJS()}/>
    </div>
  )
}

